import type { TemplateProps } from '../types';
import { ChatIcon } from '../../components/ChatIcon';

export function Trigger({ onOpen }: TemplateProps): preact.JSX.Element {
  return (
    <button
      class="yd-dock-pill"
      onClick={(e: Event) => { e.stopPropagation(); onOpen(); }}
      aria-label="Open chat"
    >
      <ChatIcon size={16} />
      <span>Help</span>
    </button>
  );
}
